var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showArea)?_c('div',{staticClass:"receipt-list-area"},[_c('div',{attrs:{"ul":"list-group"}},_vm._l((_vm.allVotes),function(vote){return _c('receipt-list-item',{key:vote.id,attrs:{"vote-object":vote}})}),1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }